import { computed } from "vue";
import { useRoute } from "vue-router";

export function useAuth() {
    const route = useRoute();

    const user = computed(() => route.meta.user?.user);
    const organization = computed(() => route.meta.user?.organization);

    const isAdmin = computed(() => user.value?.profile.roles[0]?.name === "admin");
    const isMember = computed(() => user.value?.profile.roles[0]?.name === "member");
    const isObserver = computed(() => user.value?.profile.roles[0]?.name === "observer");
    const hasSurveys = computed(() => organization.value?.has_surveys);
    const hasForms = computed(() => organization.value?.has_forms);
    const hasGovernanceForms = computed(() => organization.value?.has_governance_forms);
    const hasStandardProfileDataForms = computed(() => organization.value?.has_standard_profile_data_forms);

    const hasPublicPages = computed(() => organization.value?.has_public_pages);
    const trialDaysLeft = computed(() => organization.value?.trial_days_left);
    const onTrial = computed(() => organization.value?.on_trial);

    return { user, isAdmin, isMember, isObserver, hasSurveys, hasForms, trialDaysLeft, onTrial, hasPublicPages, hasGovernanceForms, hasStandardProfileDataForms };
}